import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../../../lib/itn-ui-kit/services/service-container";
import {
  APP_LIMIT,
  APP_OFFSET,
} from "../../../../../components/modules/appointments/utils/consts.js";

import Template from "./template.jsx";

export default class MedicalAppointments extends BaseRoute {
  @service("repositories/appointment-alt-repository") appointmentsService;

  element = (<Template />);
  revalidateOnQueryAnyChange = false;
  revalidateOnQueryKeys = ["rvClientDetail", "limit", "offset", "apptSearch", "client"];
  revalidateOnParams = ["id"];
  ignoreQueryKeys = [];
  allowManualRevalidate = false;

  async loader({ params, request }) {
    const { id } = params;

    // Get limit and search from URL query params
    const url = new URL(request.url);
    const limit = Number(url.searchParams.get("limit")) || APP_LIMIT;
    const offset = Number(url.searchParams.get("offset")) || APP_OFFSET;
    const search = url.searchParams.get("apptSearch") || undefined;
    const client = url.searchParams.get("client") || undefined;

    let appointments = [];
    let appointmentsCount = 0;

    if (id !== null && id !== "undefined" && client !== undefined) {
      try {
        appointments = await this.appointmentsService.query({
          client,
          limit,
          offset,
          ordering: "-appointment_date,appointment_time",
          search,
        });
        appointmentsCount = await this.appointmentsService.getTotalCount();
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    }

    return {
      appointments,
      appointmentsCount,
    };
  }
}
